import Cookies from "js-cookie";

export const recoverCart = () => {
  const cartToken = Cookies.get("cart");
  const parmas = new URLSearchParams(location.search);
  const recoverCart = parmas.get("cart");

  if(recoverCart && cartToken != recoverCart){
    Cookies.set("cart", recoverCart, 14);
    if(location.pathname.indexOf("/cart") === 0){
      location.reload();
    }
  }
}
